<script>
import UserApi from '@/services/Api/UserApi'
import { validationMixin } from 'vuelidate'
import { required, email, maxLength } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],

  data() {
    return {
      alternative_email: '',
      error_message: '',
      success: false,
      loading: false
    }
  },

  validations() {
    return {
      alternative_email: {
        required,
        email,
        maxLength: maxLength(150)
      }
    }
  },

  methods: {
    updateEmail() {
      this.$v.$touch()

      if (this.$v.$error) {
        return
      }

      this.loading = true

      UserApi.updateUser({
        alternative_email: this.alternative_email
      })
      .then(user => this.handleSuccess(user))
      .catch(error => this.handleError(error))
      .finally(() => (this.loading = false))
    },

    handleSuccess(user) {
      this.$auth.user(user)
      this.success = true
    },

    handleError(error) {
      this.error_message = error.response.data.alternative_email[0]
    },

    close() {
      this.$parent.$emit('close')
    }
  }
}
</script>

<template>
  <form class="Edit-alternative-email modal-card"
    @submit.prevent="updateEmail"
    novalidate>
    <header class="modal-card-head">
      <h2 class="modal-card-title" v-once>
        {{ $t('modals.alternative_email.title') }}
      </h2>
      <button class="delete"
        type="button"
        @click="close"></button>
    </header>

    <div class="modal-card-body">
      <div class="content" v-if="success">
        <p v-once>{{ $t('messages.alternative_email_added') }}</p>
      </div>
      <div class="content" v-else-if="!success && user.new_alternative_email">
        <p v-html="$t('modals.alternative_email.valid_email', {email: user.new_alternative_email})" v-once></p>
      </div>
      <div class="content" v-else>
        <p v-once>{{ $t('modals.alternative_email.text') }}</p>
        <p v-html="$t('modals.alternative_email.school_email', {email: user.email})" v-once></p>
        <p
          v-if="user.alternative_email"
          v-html="$t('modals.alternative_email.current_email', {email: user.alternative_email})"
          v-once></p>
      </div>

      <template v-if="!success">
        <b-field
          :type="error_message ? 'is-danger': ''"
          :message="$t(error_message)">
          <b-input :placeholder="$t('modals.alternative_email.placeholder')"
            v-model="alternative_email"
            type="email"
            icon="email">
          </b-input>
        </b-field>
        <p class="help is-danger"
          v-show="$v.alternative_email.$error && !$v.alternative_email.required">
          {{ $t('validation.required') }}
        </p>
        <p class="help is-danger"
          v-show="$v.alternative_email.$error && !$v.alternative_email.email">
          {{ $t('validation.email') }}
        </p>
        <p class="help is-danger"
          v-show="$v.alternative_email.$error && !$v.alternative_email.maxLength">
          {{ $t('validation.max.string', {max: 190}) }}
        </p>
      </template>
    </div>

    <footer class="modal-card-foot">
      <button class="button is-success is-fullwidth"
        type="button"
        @click="close"
        v-if="success">
        <b-icon icon="check"></b-icon>
      </button>
      <button class="button is-danger is-fullwidth"
        :class="{'is-loading': loading}"
        type="submit"
        v-else>
        {{ $t('buttons.update') }}
      </button>
    </footer>
  </form>
</template>

<style lang="scss">
  .Edit-alternative-email {
    max-width: 460px;
  }
</style>




// WEBPACK FOOTER //
// ModalEditAlternativeEmail.vue?54366d38